import { Route, Routes } from 'react-router-dom';
import SsoLoggedOut from './SsoLoggedOut';
import Tooling from './Tooling';
import ProvisionTenant from './tenant/ProvisionTenant';
import '../../../css/global-styles.less';
import Loader from './loader/Loader';
import type { UserResponseAPI } from '../types/user';
import { UserProvider } from './UserProvider';

interface Props {
    user: UserResponseAPI | null;
}

/**
 * The Draw component contains the base Router for the application. This enables the following url
 * routing hierarchy:
 *  - /
 *      - /:tenantId
 *          - /:tenantId/:adminTab
 *          - /:tenantId/flows/:flowId
 *          - /:tenantId/pages/:pageId
 */
const Draw = ({ user }: Props) => {
    if (!user) {
        return (
            <Routes>
                <Route path="/logged-out" element={<SsoLoggedOut />} />
                <Route
                    path="/user-not-found"
                    element={<ProvisionTenant container={document.getElementById('root')} />}
                />
                <Route path="/*" element={<Loader />} />
            </Routes>
        );
    }

    return (
        <UserProvider user={user}>
            <Routes>
                <Route path="/*" element={<Tooling />} />
            </Routes>
            <div id="generic-modal" />
        </UserProvider>
    );
};

export default Draw;
